module.exports = __webpack_public_path__ + "img/xiaohui3.18a0408f.jpg";